export default __webpack_public_path__ + "static/media/AvenirLTStd-Book.813557df.otf";